<template>
    <div class="singleChatMenu">
        <div v-if="!iconClicked" @click="iconClicked = !iconClicked" class="menu">
            <svg class="menuIcon" xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 515.555 515.555" height="512px" viewBox="0 0 515.555 515.555" width="512px"><g><path d="m496.679 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/><path d="m303.347 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/><path d="m110.014 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#1E64FF"/></g> </svg>
        </div>
        <div v-else @click="iconClicked = !iconClicked" class="menu">
          <svg class="menuIcon"  xmlns="http://www.w3.org/2000/svg" width="288" height="288" enable-background="new 0 0 512 512" viewBox="0 0 512 512"><path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z" fill="#1e64ff" class="color000 svgShape"></path></svg>
        </div>
        <div v-if="iconClicked" class="actions">
            <div @click="handleAction('close')">Chat abschließen</div>
            <div @click="handleAction('open')">In Eingang verschieben</div>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase/compat/app';
    import 'firebase/compat/firestore';   // for cloud firestore
    import { v4 } from 'uuid';
    import {collection, doc, updateDoc, addDoc} from "firebase/firestore";

    export default {
        name: 'ActionsSingleChat',
        props: ['currentChat'],
        data() {
            return {
               iconClicked: false,
            }
        },
        methods: {
            handleAction: async function (selectedOption, id) {
              const basePath = this.currentChat.clientId.toString() + '/' + this.currentChat.customerId.toString();
              const chatDocument = doc(this.$store.getters.getFireStore.store, basePath);
              const messageCollection = collection(this.$store.getters.getFireStore.store, basePath + '/messages');
              const messageLastUpdateDocument = doc(this.$store.getters.getFireStore.store, basePath + '/highRefreshChatInfos/lastMessageTimestamp');

              switch (selectedOption) {
                case 'close':
                  if (this.currentChat.status === 'processed') {
                    //hier noch toastr versenden
                    await addDoc(messageCollection, {
                      messageId: v4(),
                      senderId: this.currentChat.userId,
                      receiverId: this.currentChat.customerId,
                      fullEmployeeName: this.currentChat.fullEmployeeName,
                      fullCustomerName: this.currentChat.fullCustomerName,
                      messageText: "Unser Team hat den Chat geschlossen👋",
                      messageType: "service",
                      authorType: "service",
                      timestamp: Date.now(),
                      timestampHumanReadable: moment().format("DD.MM.YYYY HH:mm"),
                    });
                    await updateDoc(messageLastUpdateDocument, {
                      lastMessageTimestamp: Date.now(),
                    })
                    await updateDoc(chatDocument, {
                      status: 'closed',
                      userId: "",
                      groupId: "",
                      fullEmployeeName: "",
                      lastStatusUpdateTimestamp: Date.now(),
                    })
                  }
                  break;
                case 'open':
                  if (this.currentChat.status === 'processed') {
                    await updateDoc(chatDocument, {
                      status: 'open',
                      userId: '',
                      groupId: '',
                      lastStatusUpdateTimestamp: Date.now(),
                    });
                  }
                  break;
                case 'process':
                  alert("process");
                  break;
                default:
                  break;
              }
              this.iconClicked = !this.iconClicked;
              this.$emit('reset');
            }
        }
    }
</script>

<style lang="scss">
    .actions {
        z-index: 111;
        position: absolute;
        top: 65px;
        right: 25px;
        min-height: 40px;
        display: block;
        border-radius: 5px;
        border: 1px solid #e8e8e8;
        background: #fff;
        font-size: 14px;
        div:first-of-type {
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            padding-bottom: 15px;
        }
        div {
            display: block;
            padding: 12px;
            min-height: 40px;
            line-height: 16px;
            text-decoration: none;
            text-transform: none;
            vertical-align: middle;
            position: relative;
            cursor: pointer;
            white-space: nowrap;

            &:hover {
                background-color: #ebebeb;
            }
        }

    }

    .menu {
        cursor: pointer;
        .menuIcon {
            height: 35px;
            width: 35px;
            border: 1px solid #ebebeb;
            padding: 2px 2px 2px 2px;
            border-radius: 25px ;
        }
    }

    .singleChatMenu {
        position: relative;
        padding: 25px 25px 25px 25px;
    }

</style>
